export default __webpack_public_path__ + "static/media/no_order_new.a5c2518a.jpg";